<template>
  <div id="app">

    <!-- Dialog -->
    <el-dialog title="Muutosten ehdotus" :visible.sync="showDialog">
      <el-form :model="form" ref="form" @submit.native.prevent="sendData('form')">
        <p>
          <strong>Vahvista muutosehdotukset antamalla sähköpostisi. Tarvittaessa otamme sinuun yhteyttä.</strong>
        </p>
        <el-form-item
          prop="email"
          label="Sähköposti"
          :rules="[
          { required: true, message: 'Anna sähköpostiosoite', trigger: 'blur, submit' },
          { type: 'email', message: 'Anna toimiva sähköpostiosoite', trigger: 'blur, submit' }
         ]"
        >
          <el-input autofocus v-model="form.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
       <el-button @click="showDialog = false">Peruuta</el-button>
       <el-button type="primary" @click="sendData('form')">Lähetä</el-button>
      </span>
    </el-dialog>

    <!-- CompanyData Form -->
    <div v-if="!done">

      <search />

      <!--FORM DATA-->
      <div v-show="isCompany">
        <hr />
        <h1 class="text-center">{{ companyName }}</h1>
        <form
          id="companyData"
          @submit.prevent="submitData()"
          v-if="contacts && offices"
        >
          <el-row :gutter="30">
            <contacts></contacts>
            <offices></offices>
          </el-row>
          <input class="submit-btn" type="submit" value="Lähetä muutosehdotukset" />
        </form>
      </div>
    </div>

    <!-- Message after form submitted -->
    <div v-else>
      <h1 class="text-center">Muutokset lähetetty</h1>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import Contacts from './Contacts.vue';
  import Offices from './Offices.vue';
  import Search from './Search.vue';
  import { data } from './mixins/getData';

  export default {
    name: 'app',
    mixins: [data],
    components: { Contacts, Offices, Search },
    props: {
      'businessId': {
        type: String,
        required: true,
      },
      'district': {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        changedValues: {},
        showDialog: false,
        form: {
          email: '',
        },
        done: false,
        districts: [
          {
            value: 'itä-suomi',
            label: 'Itä-Suomi',
          },
          {
            value: 'lahti-kymi',
            label: 'Lahti-Kymi',
          },
          {
            value: 'lappi',
            label: 'Lappi',
          },
          {
            value: 'lounais-suomi',
            label: 'Lounais-Suomi',
          },
          {
            value: 'pohjanmaa',
            label: 'Pohjanmaa',
          },
          {
            value: 'pohjois-suomi',
            label: 'Pohjois-Suomi',
          },
          {
            value: 'satakunta',
            label: 'Satakunta',
          },
          {
            value: 'sisä-suomi',
            label: 'Sisä-Suomi',
          },
          {
            value: 'uusimaa',
            label: 'Uusimaa',
          },
        ],
        newDistrict: null,
        newBusinessId: null,
      };
    },

    created() {
      if (this.businessId && this.district) {
        this.getData(this.businessId, this.district);
      }
    },

    computed: {
      companyName() {
        return this.$store.getters.companyName;
      },
      contacts() {
        return this.$store.getters.contactsByDistrict;
      },
      offices() {
        return this.$store.getters.officesByDistrict;
      },
      isData() {
        if (this.contacts && this.offices) {
          return this.contacts.length > 0 && this.offices.length > 0;
        }
      },
      isCompany() {
        return this.$store.getters.companyName;
      }
    },

    methods: {
      submitData() {
        this.showDialog = true;
      },
      sendData(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post('/wp-json/wpapi/companydata/', {
              company_data: this.$store.getters.changedValues.cleanData(),
              email: this.form.email,
              company: this.$store.getters.companyName,
              district: this.$store.getters.district,
            }).then(() => {
              this.showDialog = false;
              this.form.email = '';
              this.done = true;
            });
          }
          else {
            return false;
          }
        });
      },
    },

  };
</script>

<style lang="scss">
  .text-center {
    text-align: center;
  }

  .pull-right {
    float: right;
  }

  .submit-btn {
    width: 100%;
    color: #fff !important;
    padding: 15px 30px;
    border: 0;
    -webkit-box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.75);
    -moz-box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.75);
    box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.75);
    text-decoration: none;
    display: table;
    background-color: #002663;
    &:hover {
      background-color: #6bc9db !important;
      border-color: #6bc9db !important;
    }
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #ef9100;
    border-color: #ef9100;
  }

  .add,
  .add:visited,
  .add:active {
    color: #fff !important;
    background-color: #002663 !important;
    border-color: #002663 !important;
    &:hover {
      background-color: #6bc9db !important;
      border-color: #6bc9db !important;
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?6d342bf4